import React from"react";
import WishlistButton from "./WishlistButton";
function Women(){
    return <div className="Men">

    <div className ="mencard">
 <div className="catalog-section-title"> <h1>Womens Top-Wear</h1></div>
 <div className="row">

     <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Casual Cutout Sleeve Solid Women Red Top.jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Casual Cutout Sleeve Solid Women Red Top</h6>
<p></p>
<h4> ₹649 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Printed Women Round Neck Yellow T-Shirt.jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Printed Women Round Neck Yellow T-Shirt</h6>
<p></p>
<h4> ₹549 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 
 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Casual Cutout Sleeve Solid Women Yellow Top.jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Casual Cutout Sleeve Solid Women Yellow Top</h6>
<p></p>
<h4> ₹799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


<div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Casual Cutout Sleeve Solid Women Dark Blue Top.jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Casual Cutout Sleeve Solid Women Dark Blue Top</h6>
<p></p>
<h4> ₹589 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 </div>
 </div>


 <div className ="mencard">
 <div className="catalog-section-title"> <h1>Women's Dress Materials</h1></div>
 <div className="row">

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Saara Poly Crepe Printed Salwar Suit Material  (Unstitched).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Saara Poly Crepe Printed Salwar Suit Material  (Unstitched)</h6>
<p></p>
<h4> ₹449 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>



 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Swaron Crepe Solid Kurta & Patiyala Material  (Unstitched).jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Swaron Crepe Solid Kurta & Patiyala Material  (Unstitched)</h6>
<p></p>
<h4> ₹449 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Saara Poly Crepe Printed, Floral Print Salwar Suit Material  (Unstitched).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Saara Poly Crepe Printed, Floral Print Salwar Suit Material  (Unstitched)</h6>
<p></p>
<h4> ₹449 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 
 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Reya Pure Cotton Printed Salwar Suit Material  (Unstitched).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Reya Pure Cotton Printed Salwar Suit Material  (Unstitched)</h6>
<p></p>
<h4> ₹629 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 </div>
</div>


<div className ="mencard">
 <div className="catalog-section-title"> <h1>Women's Sarees</h1></div>
 <div className="row">

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Polka Print Daily Wear Georgette Saree  (Black).jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Polka Print Daily Wear Georgette Saree  (Black)</h6>
<p></p>
<h4> ₹869 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Printed, Paisley, Floral Print Kanjivaram Poly Silk Saree  (Pack of 2, Green, Brown).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Printed, Paisley, Floral Print Kanjivaram Poly Silk Saree  (Pack of 2, Green, Brown)</h6>
<p></p>
<h4> ₹599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Paisley Banarasi Cotton Silk Saree  (Multicolor).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Paisley Banarasi Cotton Silk Saree  (Multicolor)</h6>
<p></p>
<h4> ₹584 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Striped, Woven, Embellished Banarasi Cotton Silk Saree  (Red, Black).jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Striped, Woven, Embellished Banarasi Cotton Silk Saree  (Red, Black)</h6>
<p></p>
<h4> ₹984 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
</div>
 </div>


<div className ="mencard">
 <div className="catalog-section-title"> <h1>Kurtas & Kurtis</h1></div>
 <div className="row">

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Women Checkered Pure Cotton Straight Kurta  (Dark Blue).jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Women Checkered Pure Cotton Straight Kurta  (Dark Blue)</h6>
<p></p>
<h4> ₹499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Women Printed Rayon Straight Kurta  (Orange).jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Women Printed Rayon Straight Kurta  (Orange)</h6>
<p></p>
<h4> ₹760 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Women Embroidered Rayon Asymmetric Kurta  (Yellow).jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Women Embroidered Rayon Asymmetric Kurta  (Yellow)</h6>
<p></p>
<h4> ₹629 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Women Printed, Embellished, Checkered Rayon Straight Kurta  (Dark Blue).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Women Printed, Embellished, Checkered Rayon Straight Kurta  (Dark Blue)</h6>
<p></p>
<h4> ₹539 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
 </div>
 </div>


 <div className ="mencard">
 <div className="catalog-section-title"> <h1>Women's Lehenga Cholis</h1></div>
 <div className="row">

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Embroidered Semi Stitched Lehenga Choli  (Purple).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Embroidered Semi Stitched Lehenga Choli  (Purple)</h6>
<p></p>
<h4> ₹799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Embroidered Semi Stitched Lehenga Choli  (Maroon).jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Embroidered Semi Stitched Lehenga Choli  (Maroon)</h6>
<p></p>
<h4> ₹1,079 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Embroidered Semi Stitched LehengaCholi  (Maroon).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Embroidered Semi Stitched LehengaCholi  (Maroon)</h6>
<p></p>
<h4> ₹999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Embroidered SemiStitched Lehenga Choli  (Maroon).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Embroidered SemiStitched Lehenga Choli  (Maroon)</h6>
<p></p>
<h4> ₹1,169 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
</div>
</div>



<div className ="mencard">
 <div className="catalog-section-title"> <h1>Women's Leggings</h1></div>
 <div className="row">

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/RAMYA COLLECTION Legging  (Red, White, Black, Solid).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>RAMYA COLLECTION Legging  (Red, White, Black, Solid)</h6>
<p></p>
<h4> ₹398 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/PI World Legging  (Multicolor, Solid).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>PI World Legging  (Multicolor, Solid)</h6>
<p></p>
<h4> ₹535 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/IKHLAS Churidar Legging  (Multicolor, Solid).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>IKHLAS Churidar Legging  (Multicolor, Solid)</h6>
<p></p>
<h4> ₹729 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/CN FASHION Churidar Legging  (Red, White, Solid).jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>CN FASHION Churidar Legging  (Red, White, Solid)</h6>
<p></p>
<h4> ₹789 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
</div>
 </div>



 <div className ="mencard">
 <div className="catalog-section-title"> <h1>Women's Salwars And Patialas</h1></div>
 <div className="row">

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Cotton Blend Solid Women Salwar.jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Cotton Blend Solid Women Salwar</h6>
<p></p>
<h4> ₹799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>

 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Viscose Solid Patiala.jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Viscose Solid Patiala</h6>
<p></p>
<h4> ₹799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Cotton Blend Solid Patiala.jpeg"} alt="" />
</div>
<div className="card-header">
<h6>Cotton Blend Solid Patiala</h6>
<p></p>
<h4> ₹719 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>


 <div className="pricing-column col-lg-3 col-md-6">
 <div className="card-body">
<img className ="menimage"src={process.env.PUBLIC_URL + "/images/womenimages/Viscose SolidPatiala.jpeg"}alt=""  />
</div>
<div className="card-header">
<h6>Viscose SolidPatiala</h6>
<p></p>
<h4> ₹719 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
 </div>   
 </div>
</div>
 </div>



 </div>
}
export default Women;